export default __webpack_public_path__ + "static/slide-04-97cc67475b2865e91aa0972c80e1e73b.jpg";